import { Block, InfoIconButton, Text } from '@mote/ui'
import { StyledImage } from '../ToteCardComponent.styles'
import { getMemeSrc } from '../helpers'
import { MemeContainer } from './Teply.styles'
import { Tesponse } from './Tesponse'
import { Container, Header } from './Tesponse.styles'
import { useMemeTimeout } from './useMemeTimeout'

/**
 * @typedef {Object} TeacherTesponseProps
 * @property {number} lastSeenDate
 * @property {string} studentName
 * @property {string} image
 * @property {string | null} tesponse
 * @property {string} mode
 * @property {boolean} shouldShowMeme
 * @property {boolean} shouldShowInstructionLink
 */

/**
 * @param {TeacherTesponseProps} props
 * @return {JSX.Element}
 */
export function TeacherTesponse(props) {
  const shouldShowMeme = useMemeTimeout(props.shouldShowMeme)

  if (shouldShowMeme) {
    return (
      <MemeContainer>
        <StyledImage src={getMemeSrc(props.mode, props.image)} />
      </MemeContainer>
    )
  }

  return (
    <Container className='mote-tote-card__tesponse' gap={16}>
      <Header>{props.studentName} response:</Header>
      <Tesponse mode={props.mode} tesponse={props.tesponse} />
      <Block
        className='mote-tote-card__tesponse-seen'
        layout='horizontal'
        align='center'
        gap={4}
      >
        <Text
          tag='span'
          className='mote-tote-card__tesponse-seen-text'
          fontSize={14}
          fontWeight={400}
          lineHeight='120%'
          color='#6C6C84'
        >
          {props.lastSeenDate}
        </Text>
        {props.shouldShowInstructionLink ? (
          <InfoIconButton
            size={20}
            variant='ghost'
            tooltipProps={{ content: 'What do students see?', direction: 'up' }}
            aria-label='See student view'
            href={'https://support.mote.com/hc/en-us/articles/7076116321428'}
            target={'_blank'}
            showTooltip
          />
        ) : null}
      </Block>
    </Container>
  )
}
